module.exports = __webpack_public_path__ + "Material-Design-Iconic-Font.b351bd62abcd96e924d9.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/assets/fonts/Material-Design-Iconic-Font.ttf?v=2.2.0
// module id = ../../../../../src/assets/fonts/Material-Design-Iconic-Font.ttf?v=2.2.0
// module chunks = styles